import React from 'react';
import { Box, CircularProgress, Typography, Stack, alpha, useTheme } from '@mui/material';
import GlobalStyles from '@mui/material/GlobalStyles';
import { style } from './styles';

const GeneralLoader = ({ label = 'جاري التحميل...' }) => {
  const theme = useTheme();

  return (
    <>
      <GlobalStyles styles={style} />
      <Box
        id="loader"
        className="loader"
        sx={(theme) => ({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: theme.palette.mode === 'light'
            ? `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.1)} 0%, ${alpha(theme.palette.primary.main, 0.05)} 50%, ${alpha('#ffffff', 0.95)} 100%)`
            : `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.3)} 0%, ${alpha(theme.palette.common.black, 0.8)} 50%, ${alpha(theme.palette.common.black, 0.95)} 100%)`,
          backdropFilter: 'blur(8px)',
        })}
      >
        <Stack
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            textAlign: 'center',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress
              size={80}
              thickness={2}
              sx={{
                color: theme.palette.primary.main,
                animationDuration: '1.5s',
                '& .MuiCircularProgress-circle': {
                  strokeLinecap: 'round',
                },
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 50,
                height: 50,
                borderRadius: '50%',
                background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.2)}, ${alpha(theme.palette.primary.light, 0.1)})`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                animation: 'pulse 2s ease-in-out infinite',
                '@keyframes pulse': {
                  '0%, 100%': {
                    transform: 'translate(-50%, -50%) scale(1)',
                    opacity: 1,
                  },
                  '50%': {
                    transform: 'translate(-50%, -50%) scale(1.1)',
                    opacity: 0.7,
                  },
                },
              }}
            />
          </Box>

          {label && (
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: theme.palette.mode === 'light' ? theme.palette.text.primary : theme.palette.common.white,
                letterSpacing: '0.5px',
                animation: 'fadeInUp 0.6s ease-out',
                '@keyframes fadeInUp': {
                  from: {
                    opacity: 0,
                    transform: 'translateY(20px)',
                  },
                  to: {
                    opacity: 1,
                    transform: 'translateY(0)',
                  },
                },
              }}
            >
              {label}
            </Typography>
          )}

          <Box
            sx={{
              display: 'flex',
              gap: 1,
              mt: 1,
            }}
          >
            {[0, 1, 2].map((index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: theme.palette.primary.main,
                  animation: `bounce 1.4s ease-in-out ${index * 0.2}s infinite`,
                  '@keyframes bounce': {
                    '0%, 80%, 100%': {
                      transform: 'scale(0)',
                      opacity: 0.5,
                    },
                    '40%': {
                      transform: 'scale(1)',
                      opacity: 1,
                    },
                  },
                }}
              />
            ))}
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default GeneralLoader;
